<!-- HRvecManageAssistantTeacher Template Section -->
<template>
  <div class="app-container">
    <AssisstantBar />
    
    <!-- Header Statistics Section -->
    <div class="stats-header">
      <v-container fluid>
        <v-row class="mb-6">
          <v-col cols="12" md="3">
            <div class="stat-card stat-card-primary">
              <div class="stat-icon">
                <v-icon size="32">mdi-account-multiple</v-icon>
              </div>
              <div class="stat-content">
                <div class="stat-value">{{ totalAssistantTeachers }}</div>
                <div class="stat-label">ทั้งหมด</div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="stat-card stat-card-success">
              <div class="stat-icon">
                <v-icon size="32">mdi-checkbox-marked-circle</v-icon>
              </div>
              <div class="stat-content">
                <div class="stat-value">{{ completedCommittees }}</div>
                <div class="stat-label">สมบูรณ์</div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="stat-card stat-card-warning">
              <div class="stat-icon">
                <v-icon size="32">mdi-clock-alert</v-icon>
              </div>
              <div class="stat-content">
                <div class="stat-value">{{ pendingCommittees }}</div>
                <div class="stat-label">รออนุมัติ</div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="stat-card stat-card-danger">
              <div class="stat-icon">
                <v-icon size="32">mdi-alert-circle</v-icon>
              </div>
              <div class="stat-content">
                <div class="stat-value">{{ overdueCommittees }}</div>
                <div class="stat-label">เกินกำหนด</div>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Charts Section -->
        <v-row class="mb-6">
          <v-col cols="12" md="6">
            <div class="chart-container">
              <h3 class="chart-title">สถานะการเสนอกรรมการ</h3>
              <div id="committeStatusChart"></div>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="chart-container">
              <h3 class="chart-title">สัดส่วนการอนุมัติเอกสาร</h3>
              <div id="approvalRateChart"></div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Main Content Section -->
    <v-container fluid>
      <base-material-card
        icon="mdi-account-star"
        title="เสนอรายชื่อคณะกรรมการประเมินครูผู้ช่วย"
        class="main-card px-5 py-3"
      >
        <!-- Alert Banner -->
        <v-card class="alert-banner mb-4 pa-4" outlined>
          <v-row align="center">
            <v-col cols="12" md="8">
              <div class="alert-text font-weight-bold red--text">
                <v-icon color="red" class="mr-2">mdi-information</v-icon>
                เสนอชื่อคณะกรรมการประเมินฯ ครูผู้ช่วย ตั้งแต่รอบบรรจุ ปี 2567 เป็นต้นไป
              </div>
            </v-col>
            <v-col cols="12" md="4" class="text-right">
              <v-btn
                color="info"
                depressed
                @click="manage_assistant_teacherQueryAll()"
                class="refresh-btn"
              >
                <v-icon class="mr-2">mdi-refresh</v-icon>
                รีเฟรชข้อมูล
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <!-- Search and Filter Section -->
        <div class="search-filter-section mb-4">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
            single-line
            hide-details
            dense
            filled
            class="search-field"
            clearable
          />
        </div>

        <!-- Data Table Section -->
        <div class="table-container">
          <v-data-table
            color="success"
            :loading="loading"
            :headers="headers"
            :items="manage_assistant_teachers"
            :search="search"
            group-by="mt_appoin"
            class="elevation-1 data-table"
            :single-expand="false"
            show-expand
            item-key="id"
            disable-pagination
            :loading-text="'กำลังโหลดข้อมูล...'"
          >
            <!-- Group Header Template -->
            <template v-slot:group.header="{ items, isOpen, toggle }">
              <th colspan="22" class="group-header">
                <div class="group-header-content">
                  <v-icon 
                    @click="toggle"
                    class="group-toggle"
                    :class="{ open: isOpen }"
                  >
                    {{ isOpen ? "mdi-chevron-down" : "mdi-chevron-right" }}
                  </v-icon>
                  <span class="group-info">
                    <span class="info-label">วันที่บรรจุ:</span>
                    <span class="info-value">
                      {{ items[0].mt_date_app_now | moment("add", "543 year") | moment("D MMMM YYYY") }}
                    </span>
                    
                    <span class="info-label ml-4">อายุงาน:</span>
                    <span class="info-value blue--text">
                      {{ get_govMonth_Age(items[0].mt_date_app_now) }}
                    </span>

                    <span class="info-label ml-4">กำหนดส่ง:</span>
                    <span class="info-value red--text">
                      {{ items[0].endDates | moment("add", "543 years") | moment("D MMMM YYYY") }}
                    </span>

                    <div v-if="!items[0].mt_committe_file" class="status-badge mt-2">
                      <v-chip 
                        v-if="items[0].datediffs > 30" 
                        color="red" 
                        dark
                        small
                      >
                        <v-icon small>mdi-alert</v-icon>
                        เกินกำหนด: {{ items[0].datediffs }} วัน
                      </v-chip>
                      <v-chip 
                        v-else 
                        color="warning" 
                        dark
                        small
                      >
                        <v-icon small>mdi-alert</v-icon>
                        เหลือเวลา: {{ items[0].datediffs }} วัน
                      </v-chip>
                    </div>
                  </span>
                </div>
              </th>
            </template>

            <!-- Expanded Item Template (Committee Details) -->
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="expanded-row">
                <div class="committee-details">
                  <v-simple-table class="committee-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th width="8%" class="text-center">ลำดับ</th>
                          <th width="40%" class="text-center">ชื่อ-นามสกุล</th>
                          <th width="40%" class="text-center">ตำแหน่ง</th>
                          <th width="12%" class="text-center">สถานะ</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(child, index) in item.manage_assistant_teacherpf" :key="child.id" class="committee-row">
                          <td class="text-center">{{ index + 1 }}</td>
                          <td class="text-left">{{ child.assNameCom }}</td>
                          <td class="text-left">
                            <v-chip 
                              v-if="child.assistantcommitteePositon === '1' || child.assistantcommitteePositon === 1"
                              small
                              color="purple"
                              text-color="white"
                            >
                              กรรมการ (ศึกษานิเทศก์ หรือผู้ทรงคุณวุฒิ)
                            </v-chip>
                            <v-chip 
                              v-else-if="child.assistantcommitteePositon === '2' || child.assistantcommitteePositon === 2"
                              small
                              color="blue"
                              text-color="white"
                            >
                              กรรมการและเลขานุการ
                            </v-chip>
                          </td>
                          <td class="text-center">
                            <v-icon color="success" small>mdi-checkbox-marked-circle</v-icon>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </td>
            </template>

            <!-- Admission Status Column -->
            <template v-slot:item.mt_admissions_status="{ item }">
              <v-chip
                v-if="item.mt_admissions_status === 'missing'"
                small
                color="red"
                text-color="white"
              >
                <v-icon x-small class="mr-1">mdi-alert</v-icon>
                ไม่มารายงานตัว
              </v-chip>
              <v-chip
                v-else
                small
                color="green"
                text-color="white"
              >
                <v-icon x-small class="mr-1">mdi-check</v-icon>
                มารายงานตัว
              </v-chip>
            </template>

            <!-- Admission File Column -->
            <template v-slot:item.mt_admissions_file="{ item }">
              <div v-if="item.mt_admissions_file">
                <v-btn
                  icon
                  small
                  color="info"
                  :href="'/HRcommitteeAssistantTeach/' + item.mt_admissions_file"
                  target="_blank"
                  title="ดูไฟล์"
                >
                  <v-icon small>mdi-file-pdf</v-icon>
                </v-btn>
              </div>
            </template>

            <!-- Committee Status Column -->
            <template v-slot:item.mt_committe_status="{ item }">
              <div class="status-indicator">
                <v-chip
                  v-if="item.mt_committe_status === 'CF'"
                  small
                  color="success"
                  text-color="white"
                  class="status-chip"
                >
                  <v-icon x-small class="mr-1">mdi-checkbox-marked</v-icon>
                  สมบูรณ์
                </v-chip>
                <v-chip
                  v-else-if="item.mt_committe_status === 'CC'"
                  small
                  color="red"
                  text-color="white"
                  class="status-chip"
                >
                  <v-icon x-small class="mr-1">mdi-close</v-icon>
                  ยกเลิก
                </v-chip>
                <v-btn
                  v-else
                  color="warning"
                  fab
                  x-small
                  @click="assistantcommitteeAdd(item.mt_id)"
                  title="เพิ่มกรรมการ"
                >
                  <v-icon x-small>mdi-plus</v-icon>
                </v-btn>
              </div>
            </template>

            <!-- Committee File Column -->
            <template v-slot:item.mt_committe_file="{ item }">
              <div class="file-actions">
                <div v-if="item.mt_committe_status === 'CF'">
                  <v-btn
                    v-if="item.mt_committe_file"
                    icon
                    small
                    color="info"
                    @click="viewpdfmt_committe_file(item.mt_committe_file)"
                    title="ดูไฟล์"
                  >
                    <v-icon small>mdi-file-pdf</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    color="success"
                    x-small
                    rounded
                    @click="pdfattactment(item.mt_id)"
                  >
                    <v-icon x-small class="mr-1">mdi-paperclip</v-icon>
                    แนบไฟล์
                    <v-icon x-small color="red" class="ml-1">mdi-alert</v-icon>
                  </v-btn>
                </div>
                <v-chip v-else color="red" text-color="white" small>
                  <v-icon x-small class="mr-1">mdi-alert</v-icon>
                  ยังไม่แนบ
                </v-chip>
              </div>
            </template>

            <!-- Committee DateTime Column -->
            <template v-slot:item.mt_committe_datetime="{ item }">
              <div v-if="item.mt_committe_file" class="datetime-cell">
                {{ item.mt_committe_datetime | moment("add", "543 years") | moment("D MMM YYYY HH:mm") }}
              </div>
              <div v-else>
                <v-chip color="red" text-color="white" small>
                  <v-icon x-small class="mr-1">mdi-alert</v-icon>
                  ยังไม่แนบ
                </v-chip>
              </div>
            </template>

            <!-- Approval Status Column -->
            <template v-slot:item.mt_committe_ipaapprove="{ item }">
              <v-chip
                v-if="item.mt_committe_ipaapprove === 'pass'"
                small
                color="success"
                text-color="white"
              >
                <v-icon x-small class="mr-1">mdi-check-circle</v-icon>
                ถูกต้อง
              </v-chip>
              <v-chip
                v-else-if="item.mt_committe_ipaapprove === 'dontpass'"
                small
                color="red"
                text-color="white"
              >
                <v-icon x-small class="mr-1">mdi-alert-circle</v-icon>
                ไม่ถูกต้อง
              </v-chip>
              <span v-else class="pending-badge">
                <v-icon x-small>mdi-clock</v-icon>
                รอตรวจ
              </span>
            </template>

            <!-- Approval Detail Column -->
            <template v-slot:item.mt_committe_ipaapprove_detail="{ item }">
              <div v-if="item.mt_committe_ipaapprove === 'dontpass'" class="error-detail">
                {{ item.mt_committe_ipaapprove_detail }}
              </div>
            </template>

            <!-- Actions Column -->
            <template v-slot:item.actions="{ item }">
              <div class="action-buttons">
                <div v-if="item.mt_collegeCC === 'CC'" class="error-notice">
                  <v-chip color="red" text-color="white" small>
                    <v-icon x-small class="mr-1">mdi-information</v-icon>
                    {{ item.mt_collegeCC_datail }}
                  </v-chip>
                </div>
                <div v-if="item.mt_committe_status === 'CF'">
                  <v-btn
                    fab
                    x-small
                    v-if="item.mt_admissions_status === 'receipt'"
                    color="warning"
                    @click="manage_assistant_teacherEdit(item.mt_id)"
                    title="ขอยกเลิก/แก้ไข"
                  >
                    <v-icon x-small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-icon v-else color="grey" x-small>mdi-lock</v-icon>
                </div>
              </div>
            </template>

            <!-- No Results Alert -->
            <template v-slot:no-data>
              <div class="no-data-container">
                <v-icon size="48" color="grey">mdi-database-search</v-icon>
                <p class="mt-2">ไม่พบข้อมูลที่ค้นหา "{{ search }}"</p>
              </div>
            </template>
          </v-data-table>
        </div>
      </base-material-card>

      <!-- Committee Selection Dialog -->
      <v-layout row justify-center>
        <v-dialog v-model="assistantcommitteeDialog" persistent max-width="75%">
          <v-card class="dialog-card">
            <v-card-title class="dialog-title">
              <v-icon class="mr-2" color="primary">mdi-account-multiple-plus</v-icon>
              เพิ่มกรรมการประเมิน
            </v-card-title>

            <v-card-text class="dialog-body">
              <!-- Teacher Information -->
              <v-list class="teacher-info-list" two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-account-card</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ editmanage_assistant_teacher.mt_id_card }}
                    </v-list-item-title>
                    <v-list-item-subtitle>เลขบัตรประชาชน</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-icon>
                    <v-icon color="primary">mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ editmanage_assistant_teacher.mt_title_s }}{{ editmanage_assistant_teacher.mt_frist_name }} {{ editmanage_assistant_teacher.mt_last_name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>ชื่อ-นามสกุล</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-icon>
                    <v-icon color="primary">mdi-school</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ editmanage_assistant_teacher.name_branch }}
                    </v-list-item-title>
                    <v-list-item-subtitle>สาขาวิชา</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <!-- Committee Selection Table -->
              <v-card class="committee-selection-card mt-4" outlined>
                <v-simple-table fixed-header height="400px">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th width="8%" class="text-center">ลำดับ</th>
                        <th width="36%" class="text-center">ผู้ประเมิน</th>
                        <th width="36%" class="text-center">ตำแหน่ง</th>
                        <th width="20%" class="text-center">การจัดการ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- Position 1: Director -->
                      <tr class="committee-row position-1">
                        <td class="text-center">1</td>
                        <td class="text-center font-weight-bold">ผู้อำนวยการวิทยาลัย</td>
                        <td class="text-center">ประธานกรรมการโดยตำแหน่ง</td>
                        <td class="text-center">
                          <v-icon color="success" small>mdi-lock</v-icon>
                        </td>
                      </tr>

                      <!-- Position 2: Teacher in School -->
                      <tr class="committee-row position-2">
                        <td class="text-center">2</td>
                        <td class="position-content">
                          <div v-if="editassistantcommitteeL2Status === false">
                            <div v-if="assistantcommitteeL2s.assistantCommitteeIDcardCommittee" class="selected-person">
                              <div class="font-weight-bold">
                                {{ assistantcommitteeL2s.title_s }}{{ assistantcommitteeL2s.frist_name }} {{ assistantcommitteeL2s.last_name }}
                              </div>
                              <div class="person-position">
                                {{ assistantcommitteeL2s.position_name }} - {{ assistantcommitteeL2s.rang_name }}
                              </div>
                            </div>
                            <v-autocomplete
                              v-else
                              v-model="addassistantcommittee.assistantCommitteeIDcardCommitteeL2"
                              :items="personnel_temporarys"
                              item-text="frist_names"
                              item-value="id_card"
                              label="เลือกกรรมการและเลขานุการ/ใกล้เคียง"
                              outlined
                              dense
                              hide-details
                            >
                              <template v-slot:item="{ item }">
                                <div class="autocomplete-item">
                                  <div class="font-weight-bold">{{ item.frist_names }}</div>
                                  <div class="text-caption">{{ item.position_name }}</div>
                                </div>
                              </template>
                            </v-autocomplete>
                          </div>

                          <v-autocomplete
                            v-if="editassistantcommitteeL2Status === true"
                            v-model="editassistantcommitteeL2.assistantCommitteeIDcardCommittee"
                            :items="personnel_temporarys"
                            item-text="frist_names"
                            item-value="id_card"
                            label="แก้ไข กรรมการและเลขานุการ/ใกล้เคียง"
                            outlined
                            dense
                            hide-details
                          >
                            <template v-slot:item="{ item }">
                              <div class="autocomplete-item">
                                <div class="font-weight-bold">{{ item.frist_names }}</div>
                                <div class="text-caption">{{ item.position_name }}</div>
                              </div>
                            </template>
                          </v-autocomplete>
                        </td>
                        <td class="text-center">กรรมการและเลขานุการ/ใกล้เคียง</td>
                        <td class="text-center">
                          <div v-if="editassistantcommitteeL2Status === false">
                            <v-btn
                              v-if="assistantcommitteeL2s.assistantCommitteeIDcardCommittee"                         
                              color="warning"
                              @click="assistantcommitteeL2Edit()"
                              title="แก้ไข"
                            >
                              <v-icon x-small>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              v-else                             
                              color="success"
                              @click="assistantcommitteeL2Save()"
                              title="บันทึก"
                            >
                              <v-icon x-small>mdi-check</v-icon>
                            </v-btn>
                          </div>
                          <v-btn
                            v-else                         
                            color="primary"
                            @click="assistantcommitteeL2SaveEditL2()"
                            title="บันทึกการแก้ไข"
                          >
                            <v-icon x-small>mdi-content-save</v-icon>
                          </v-btn>
                        </td>
                      </tr>

                      <!-- Position 3: Qualified Expert -->
                      <tr class="committee-row position-3">
                        <td class="text-center">3</td>
                        <td class="position-content">
                          <div v-if="editassistantcommitteeL1Status === false">
                            <div v-if="assistantcommitteeL1s.assistantCommitteeIDcardCommittee" class="selected-person">
                              <div class="font-weight-bold">
                                {{ assistantcommitteeL1s.assistantcommitteeQualifiedTitles }}{{ assistantcommitteeL1s.assistantcommitteeQualifiedFristname }} {{ assistantcommitteeL1s.assistantcommitteeQualifiedLastname }}
                              </div>
                              <div class="person-position">
                                {{ assistantcommitteeL1s.assistantcommitteeQualifiedPosition }}
                              </div>
                            </div>
                            <v-autocomplete
                              v-else
                              v-model="addassistantcommittee.assistantCommitteeIDcardCommitteeL1"
                              :items="assistantcommitteequalifieds"
                              item-text="assistantcommitteequalifiedNAME"
                              item-value="assistantcommitteeQualifiedIDcard"
                              label="เลือกผู้ทรงคุณวุฒิ"
                              outlined
                              dense
                              hide-details
                            >
                              <template v-slot:item="{ item }">
                                <div class="autocomplete-item">
                                  <div class="font-weight-bold">{{ item.assistantcommitteequalifiedNAME }}</div>
                                  <div class="text-caption">{{ item.assistantcommitteeQualifiedPosition }}</div>
                                </div>
                              </template>
                            </v-autocomplete>
                          </div>

                          <v-autocomplete
                            v-if="editassistantcommitteeL1Status === true"
                            v-model="editassistantcommitteeL1.assistantCommitteeIDcardCommittee"
                            :items="assistantcommitteequalifieds"
                            item-text="assistantcommitteequalifiedNAME"
                            item-value="assistantcommitteeQualifiedIDcard"
                            label="เลือกผู้ทรงคุณวุฒิ"
                            outlined
                            dense
                            hide-details
                          >
                            <template v-slot:item="{ item }">
                              <div class="autocomplete-item">
                                <div class="font-weight-bold">{{ item.assistantcommitteequalifiedNAME }}</div>
                                <div class="text-caption">{{ item.assistantcommitteeQualifiedPosition }}</div>
                              </div>
                            </template>
                          </v-autocomplete>
                        </td>
                        <td class="text-center">กรรมการ (ศึกษานิเทศก์ หรือผู้ทรงคุณวุฒิ)</td>
                        <td class="text-center">
                          <div v-if="editassistantcommitteeL1Status === false">
                            <v-btn
                              v-if="assistantcommitteeL1s.assistantCommitteeIDcardCommittee"                     
                              color="warning"
                              @click="assistantcommitteeL1Edit()"
                              title="แก้ไข"
                            >
                              <v-icon x-small>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              v-else                      
                              color="success"
                              @click="assistantcommitteeL1Save()"
                              title="บันทึก"
                            >
                              <v-icon x-small>mdi-check</v-icon>
                            </v-btn>
                          </div>
                          <v-btn
                            v-else                       
                            color="primary"
                            @click="assistantcommitteeL1SaveEditL1()"
                            title="บันทึกการแก้ไข"
                          >
                            <v-icon x-small>mdi-content-save</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-card-text>

            <v-card-actions class="dialog-actions">
              <v-spacer></v-spacer>
              <v-btn
                outlined
                @click="assistantcommitteeDialog = false"
                rounded
              >
                <v-icon small class="mr-1">mdi-close</v-icon>
                ยกเลิก
              </v-btn>
              <v-btn
                v-if="assistantcommitteeL1s.assistantCommitteeIDcardCommittee && assistantcommitteeL2s.assistantCommitteeIDcardCommittee"
                color="primary"
                @click="assistantcommitteeDialogSubmit()"
                rounded
              >
                <v-icon small class="mr-1">mdi-content-save</v-icon>
                บันทึกข้อมูล
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- File Attachment Dialog -->
      <v-layout row justify-center>
        <v-dialog v-model="manage_assistant_teacherAttachmentDialog" persistent max-width="75%">
          <v-card class="dialog-card">
            <v-card-title class="dialog-title">
              <v-icon class="mr-2" color="primary">mdi-paperclip</v-icon>
              แนบไฟล์หนังสือนำส่ง
            </v-card-title>

            <v-card-text class="dialog-body">
              <!-- Teacher Information -->
              <v-list class="teacher-info-list mb-6" two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-account-card</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ editmanage_assistant_teacher.mt_id_card }}
                    </v-list-item-title>
                    <v-list-item-subtitle>เลขบัตรประชาชน</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-icon>
                    <v-icon color="primary">mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ editmanage_assistant_teacher.mt_title_s }}{{ editmanage_assistant_teacher.mt_frist_name }} {{ editmanage_assistant_teacher.mt_last_name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>ชื่อ-นามสกุล</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <!-- Committee Summary -->
              <v-card class="committee-summary-card mb-6" outlined>
                <v-simple-table fixed-header height="200px">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th width="10%" class="text-center">ลำดับ</th>
                        <th width="40%" class="text-center">ผู้ประเมิน</th>
                        <th width="50%" class="text-center">ตำแหน่ง</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center">1</td>
                        <td class="text-center">ผู้อำนวยการวิทยาลัย</td>
                        <td class="text-center">ประธานกรรมการ</td>
                      </tr>
                      <tr v-if="assistantcommitteeL2s.assistantCommitteeIDcardCommittee">
                        <td class="text-center">2</td>
                        <td class="text-left">
                          {{ assistantcommitteeL2s.title_s }}{{ assistantcommitteeL2s.frist_name }} {{ assistantcommitteeL2s.last_name }}
                        </td>
                        <td class="text-left">กรรมการและเลขานุการ/ใกล้เคียง</td>
                      </tr>
                      <tr v-if="assistantcommitteeL1s.assistantCommitteeIDcardCommittee">
                        <td class="text-center">3</td>
                        <td class="text-left">
                          {{ assistantcommitteeL1s.assistantcommitteeQualifiedTitles }}{{ assistantcommitteeL1s.assistantcommitteeQualifiedFristname }} {{ assistantcommitteeL1s.assistantcommitteeQualifiedLastname }}
                        </td>
                        <td class="text-left">ผู้ทรงคุณวุฒิ</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>

              <!-- File Upload and Print -->
              <v-row class="file-upload-section">
                <v-col cols="12" md="4">
                  <v-btn
                    block
                    rounded
                    color="info"
                    :href="`#/college/print_assistantcommittee_present/?mt_id_card=${editmanage_assistant_teacher.mt_id_card}&mt_times=${editmanage_assistant_teacher.mt_times}&mt_years=${editmanage_assistant_teacher.mt_years}&mt_id=${editmanage_assistant_teacher.mt_id}`"
                    target="_blank"
                    class="print-btn"
                  >
                    <v-icon class="mr-2">mdi-printer</v-icon>
                    พิมพ์แบบเสนอรายชื่อ
                  </v-btn>
                </v-col>
                <v-col cols="12" md="8">
                  <v-form ref="manage_assistant_teacherAttactmentDialogform" lazy-validation>
                    <v-file-input
                      v-model="mt_committe_file"
                      accept=".pdf"
                      name="mt_committe_file"
                      color="primary"
                      label="เลือกไฟล์เสนอรายชื่อกรรมการ (PDF)"
                      placeholder="คลิกเพื่อเลือกไฟล์"
                      prepend-icon="mdi-paperclip"
                      outlined
                      rounded
                      dense
                      clearable
                      :show-size="1000"
                      :rules="rules"
                      hide-details="auto"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                          v-if="index < 2"
                          color="primary"
                          text-color="white"
                          label
                          small
                          close
                        >
                          {{ text }}
                        </v-chip>
                        <span v-else-if="index === 2" class="text-caption grey--text ml-2">
                          +{{ mt_committe_file.length - 2 }} ไฟล์
                        </span>
                      </template>
                    </v-file-input>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="dialog-actions">
              <v-spacer></v-spacer>
              <v-btn
                outlined
                @click="manage_assistant_teacherAttachmentDialog = false"
                rounded
              >
                <v-icon small class="mr-1">mdi-close</v-icon>
                ยกเลิก
              </v-btn>
              <v-btn
                color="success"
                @click="assistantcommitteeFileattachmentDialogSubmit()"
                rounded
              >
                <v-icon small class="mr-1">mdi-content-save</v-icon>
                บันทึกไฟล์
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- Request Cancellation Dialog -->
      <v-layout row justify-center>
        <v-dialog v-model="committeeCCdialog" persistent max-width="50%">
          <v-card class="dialog-card">
            <v-card-title class="dialog-title error-title">
              <v-icon class="mr-2" color="red">mdi-alert-circle</v-icon>
              ขอดำเนินการเกี่ยวกับกรรมการประเมิน
            </v-card-title>

            <v-card-text class="dialog-body">
              <v-form ref="committeeCCform" lazy-validation>
                <!-- Teacher Information -->
                <div class="teacher-details-section mb-6">
                  <div class="detail-row">
                    <span class="detail-label">สถานศึกษา:</span>
                    <span class="detail-value">{{ editmanage_assistant_teacher.college_name }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-label">รหัสบัตรประชาชน:</span>
                    <span class="detail-value">{{ editmanage_assistant_teacher.mt_id_card }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-label">ชื่อ-นามสกุล:</span>
                    <span class="detail-value">
                      {{ editmanage_assistant_teacher.mt_title_s }}{{ editmanage_assistant_teacher.mt_frist_name }} {{ editmanage_assistant_teacher.mt_last_name }}
                    </span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-label">วันที่บรรจุ:</span>
                    <span class="detail-value">{{ editmanage_assistant_teacher.mt_date_app_now }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-label">คำสั่งที่บรรจุ:</span>
                    <span class="detail-value">{{ editmanage_assistant_teacher.mt_order_app }}</span>
                  </div>
                </div>

                <!-- Action Selection -->
                <div class="action-selection-section mb-6">
                  <div class="section-title">เลือกการดำเนินการ</div>
                  <v-radio-group
                    v-model="editmanage_assistant_teacher.mt_collegeCC"
                    column
                  >
                    <v-radio
                      v-if="editmanage_assistant_teacher.pertem_assistantFileIpastatus === 'notice'"
                      value="cancelfile"
                      class="radio-option"
                    >
                      <template v-slot:label>
                        <span>ขอยกเลิกไฟล์แนบ</span>
                      </template>
                    </v-radio>
                    <v-radio
                      v-if="editmanage_assistant_teacher.pertem_assistantFileIpastatus === 'notice'"
                      value="cancelcommittee"
                      class="radio-option"
                    >
                      <template v-slot:label>
                        <span>ขอแก้ไข/เปลี่ยนแปลงผู้ทรงคุณวุฒิ</span>
                      </template>
                    </v-radio>
                    <v-radio
                      v-if="editmanage_assistant_teacher.pertem_assistantFileIpastatus === 'notice'"
                      value="cancelcommittee"
                      class="radio-option"
                    >
                      <template v-slot:label>
                        <span>ขอแก้ไข/เปลี่ยนแปลงกรรมการและเลขานุการ</span>
                      </template>
                    </v-radio>
                    <v-radio
                      v-if="editmanage_assistant_teacher.pertem_assistantFileIpastatus !== 'notice' && editmanage_assistant_teacher.pertem_assistantFileIpastatus !== 'process'"
                      value="cancelfile"
                      class="radio-option"
                    >
                      <template v-slot:label>
                        <span>ขอยกเลิกไฟล์แนบ</span>
                      </template>
                    </v-radio>
                    <v-radio
                      v-if="editmanage_assistant_teacher.pertem_assistantFileIpastatus !== 'notice' && editmanage_assistant_teacher.pertem_assistantFileIpastatus !== 'process'"
                      value="cancelcommittee"
                      class="radio-option"
                    >
                      <template v-slot:label>
                        <span>ขอแก้ไขกรรมการประเมิน</span>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>

                <!-- Reason Input -->
                <v-text-field
                  v-if="editmanage_assistant_teacher.pertem_assistantFileIpastatus !== 'process'"
                  v-model="editmanage_assistant_teacher.mt_collegeCC_datail"
                  label="เหตุผลในการขอยกเลิก/แก้ไข"
                  outlined
                  dense
                  multi-line
                  rows="3"
                  :rules="[v => !!v || 'กรุณาระบุเหตุผล']"
                  placeholder="กรุณาอธิบายเหตุผล"
                />

                <!-- Process Status Alert -->
                <div v-if="editmanage_assistant_teacher.pertem_assistantFileIpastatus === 'process'" class="process-alert">
                  <v-icon color="red" class="mr-2">mdi-alert</v-icon>
                  <span class="alert-text">อยู่ระหว่างออกคำสั่งแต่งตั้งกรรมการประเมินฯ ไม่สามารถแก้ไขได้ในขณะนี้</span>
                </div>

                <!-- Warning Message -->
                <v-alert
                  v-if="editmanage_assistant_teacher.pertem_assistantFileIpastatus !== 'process'"
                  type="warning"
                  colored-border
                  border="left"
                  class="mt-4"
                >
                  <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
                  <span class="warning-text">
                    การแก้ไข/เปลี่ยนแปลงกรรมการฯ หลังจากประกาศคำสั่งแต่งตั้ง อาจจะมีผลต่อรอบการประเมินล่าช้า
                  </span>
                </v-alert>
              </v-form>
            </v-card-text>

            <v-card-actions class="dialog-actions">
              <v-spacer></v-spacer>
              <v-btn
                outlined
                color="grey"
                @click="committeeCCdialog = false"
                rounded
              >
                <v-icon small class="mr-1">mdi-close</v-icon>
                ยกเลิก
              </v-btn>
              <v-btn
                v-if="editmanage_assistant_teacher.pertem_assistantFileIpastatus !== 'process'"
                color="success"
                @click="committeeCCdialogSubmit()"
                rounded
              >
                <v-icon small class="mr-1">mdi-checkbox-marked-circle</v-icon>
                ยืนยันการดำเนินการ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- PDF Viewer Dialog -->
      <v-layout row justify-center>
        <v-dialog v-model="pdfmt_committe_filedialog" max-width="90%">
          <v-card class="pdf-viewer-card elevation-2">
            <v-card-title class="pdf-title">
              <v-icon class="mr-2">mdi-file-pdf</v-icon>
              ดูเอกสาร
              <v-spacer></v-spacer>
              <v-btn icon @click="pdfmt_committe_filedialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <embed
              :src="'/HRcommitteeAssistantTeach/' + pdf_files"
              width="100%"
              height="600px"
              type="application/pdf"
            />
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>

<!-- HRvecManageAssistantTeacher Script Section -->
<script>
import AssisstantBar from "../../components/college/assisstantBar.vue";
import ApexCharts from 'apexcharts';

export default {
  name: "HRvecManageAssistantTeacher",
  data() {
    return {
      expanded: [],
      singleExpand: false,
      loading: true,
      ApiKey: "HRvec2021",
      valid: true,
      assistantcommitteeDialog: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      manage_assistant_teachers: [],
      editmanage_assistant_teacher: [],
      colleges: [],
      userstatus: [],
      search: "",
      pagination: {},
      headers: [
        { text: "วันที่บรรจุ", align: "center", value: "mt_appoin", sortable: true },
        { text: "สาขาวิชา", align: "center", value: "mt_id_branch", sortable: true },
        { text: "รหัสบัตร", align: "center", value: "mt_id_card" },
        { text: "ชื่อ-นามสกุล", align: "center", value: "mt_name" },
        { text: "วุฒิการศึกษา", align: "center", value: "mt_ed_abb" },
        { text: "เอกวิชา", align: "center", value: "mt_ed_name" },
        { text: "สถานะ", align: "center", value: "mt_admissions_status" },
        { text: "กรรมการประเมิน", align: "center", value: "mt_committe_status" },
        { text: "ไฟล์เสนอ", align: "center", value: "mt_committe_file" },
        { text: "วันที่แนบเสนอ", align: "center", value: "mt_committe_datetime" },
        { text: "การตรวจสอบเอกสาร", align: "center", value: "mt_committe_ipaapprove" },
        { text: "หมายเหตุ", align: "center", value: "mt_committe_ipaapprove_detail" },
        { text: "ดำเนินการ", align: "center", value: "actions" },
        { text: "รายชื่อกรรมการ", align: "center", value: "data-table-expand", width: "10%" }
      ],
      rowsperpage: [25, 50, 100, { text: "All", value: -1 }],
      data_syslog: {},
      mt_admissions_status_select: [
        { text: "มารายงานตัว", value: "receipt" },
        { text: "ไม่มารายงานตัว", value: "missing" }
      ],
      mt_examtype_select: [
        { text: "คัดเลือก(ภายใน)", value: "select" },
        { text: "แข่งขัน(ภายนอก)", value: "recruit" }
      ],
      mt_examgroup_select: [
        { text: "ทั่วไป", value: "general" },
        { text: "ชายแดนภาคใต้", value: "southern" }
      ],
      collegeCheck: [],
      rules: [
        value => !value || value.size < 1048576 || "ไฟล์ไม่เกิน 1 MB",
        value => !!value || "กรุณาเลือกไฟล์"
      ],
      assistantcommitteequalifieds: [],
      personnel_temporarys: [],
      addassistantcommittee: {},
      editassistantcommitteeL1: [],
      editassistantcommitteeL1Update: {},
      editassistantcommitteeL2: [],
      editassistantcommitteeL2Update: {},
      editassistantcommitteeL1Status: false,
      editassistantcommitteeL2Status: false,
      manage_assistant_teacherAttachmentDialog: false,
      assistantcommitteeL1s: [],
      assistantcommitteeL2s: [],
      personnel_temporarysSeacrh: [],
      linealerts: {},
      mt_committe_file: null,
      pdfmt_committe_filedialog: false,
      pdf_files: [],
      massege_cc: [],
      committeeCCdialog: false,
      chartInstances: {}
    };
  },
  
  async mounted() {
    await this.collegeQuery();
    await this.manage_assistant_teacherQueryAll();
    await this.personnel_temporaryQuery();
    await this.assistantcommitteequalifiedQuery();
    this.$nextTick(() => {
      this.initializeCharts();
    });
  },

  watch: {
    manage_assistant_teachers() {
      this.$nextTick(() => {
        this.updateCharts();
      });
    }
  },

  methods: {
    /**
     * Initialize ApexCharts for statistics visualization
     */
    initializeCharts() {
      // Committee Status Chart
      const committeeStatusOptions = {
        chart: {
          type: 'donut',
          height: 350,
          fontFamily: "'Segoe UI', sans-serif",
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
          }
        },
        labels: ['สมบูรณ์', 'รออนุมัติ', 'ยกเลิก'],
        colors: ['#4CAF50', '#FFC107', '#F44336'],
        plotOptions: {
          pie: {
            donut: {
              size: '65%',
              labels: {
                show: true,
                name: {
                  fontSize: '14px',
                  fontWeight: 600
                },
                value: {
                  fontSize: '16px',
                  fontWeight: 700
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return Math.round(val) + "%";
          }
        },
        tooltip: {
          theme: 'light',
          y: {
            formatter: function(val) {
              return val + " คน";
            }
          }
        },
        legend: {
          position: 'bottom',
          fontSize: '13px',
          fontFamily: "'Segoe UI', sans-serif"
        }
      };

      const committeeStatusChart = new ApexCharts(
        document.querySelector("#committeStatusChart"),
        {
          ...committeeStatusOptions,
          series: [this.completedCommittees, this.pendingCommittees, this.cancelledCommittees]
        }
      );
      committeeStatusChart.render();
      this.chartInstances.statusChart = committeeStatusChart;

      // Approval Rate Chart
      const approvalRateOptions = {
        chart: {
          type: 'bar',
          height: 350,
          fontFamily: "'Segoe UI', sans-serif",
          toolbar: {
            show: true
          }
        },
        colors: ['#2196F3', '#4CAF50', '#FF9800'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '65%',
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: 0,
          style: {
            fontSize: '12px',
            fontWeight: 600
          },
          formatter: function(val) {
            return Math.round(val) + "%";
          }
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#f3f3f3']
        },
        tooltip: {
          shared: false,
          intersect: false,
          y: {
            formatter: function(val) {
              return Math.round(val) + "%";
            }
          }
        },
        xaxis: {
          categories: ['ถูกต้อง', 'ไม่ถูกต้อง', 'รอตรวจ'],
          tickAmount: 5,
          max: 100
        },
        legend: {
          position: 'bottom'
        }
      };

      const passedCount = this.manage_assistant_teachers.filter(t => t.mt_committe_ipaapprove === 'pass').length;
      const failedCount = this.manage_assistant_teachers.filter(t => t.mt_committe_ipaapprove === 'dontpass').length;
      const pendingCount = this.manage_assistant_teachers.filter(t => !t.mt_committe_ipaapprove || t.mt_committe_ipaapprove === '').length;
      const total = this.manage_assistant_teachers.length || 1;

      const approvalRateChart = new ApexCharts(
        document.querySelector("#approvalRateChart"),
        {
          ...approvalRateOptions,
          series: [
            {
              name: 'ร้อยละของการอนุมัติ',
              data: [
                Math.round((passedCount / total) * 100),
                Math.round((failedCount / total) * 100),
                Math.round((pendingCount / total) * 100)
              ]
            }
          ]
        }
      );
      approvalRateChart.render();
      this.chartInstances.approvalChart = approvalRateChart;
    },

    /**
     * Update charts when data changes
     */
    updateCharts() {
      if (this.chartInstances.statusChart) {
        this.chartInstances.statusChart.updateSeries([
          this.completedCommittees,
          this.pendingCommittees,
          this.cancelledCommittees
        ]);
      }

      if (this.chartInstances.approvalChart) {
        const passedCount = this.manage_assistant_teachers.filter(t => t.mt_committe_ipaapprove === 'pass').length;
        const failedCount = this.manage_assistant_teachers.filter(t => t.mt_committe_ipaapprove === 'dontpass').length;
        const pendingCount = this.manage_assistant_teachers.filter(t => !t.mt_committe_ipaapprove || t.mt_committe_ipaapprove === '').length;
        const total = this.manage_assistant_teachers.length || 1;

        this.chartInstances.approvalChart.updateSeries([
          {
            name: 'ร้อยละของการอนุมัติ',
            data: [
              Math.round((passedCount / total) * 100),
              Math.round((failedCount / total) * 100),
              Math.round((pendingCount / total) * 100)
            ]
          }
        ]);
      }
    },

    /**
     * View PDF file
     */
    async viewpdfmt_committe_file(mt_committe_file) {
      this.pdf_files = mt_committe_file;
      this.pdfmt_committe_filedialog = true;
    },

    /**
     * Open attachment dialog for file upload
     */
    async pdfattactment(mt_id) {
      let result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_id: mt_id
      });
      this.editmanage_assistant_teacher = result.data;
      await this.assistantcommitteeL1Query();
      await this.assistantcommitteeL2Query();
      this.manage_assistant_teacherAttachmentDialog = true;
    },

    /**
     * Submit committee cancellation request
     */
    async committeeCCdialogSubmit() {
      if (this.$refs.committeeCCform.validate()) {
        this.editmanage_assistant_teacher.ApiKey = this.ApiKey;
        this.editmanage_assistant_teacher.mt_collegeCC = "CC";
        this.editmanage_assistant_teacher.mt_committe_status = "CC";
        
        let result = await this.$http.post(
          "manage_assistant_teacher.update.php",
          this.editmanage_assistant_teacher
        );
        
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });

          this.linealerts.ApiKey = this.ApiKey;
          this.linealerts.college_name = this.collegeCheck.college_name;
          this.linealerts.details = String(
            "งานครูผู้ช่วย : ขอยกเลิกแนบไฟล์คำสั่งแต่งตั้งคณะกรรมการ : " +
            this.editmanage_assistant_teacher.mt_id_card + " : " +
            this.editmanage_assistant_teacher.mt_title_s +
            this.editmanage_assistant_teacher.mt_frist_name + " " +
            this.editmanage_assistant_teacher.mt_last_name
          );
          this.linealerts.datetime = this.date_today;

          await this.$http.post("linenotify_hr.php", this.linealerts);
          this.manage_assistant_teacherQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.committeeCCdialog = false;
      }
    },

    /**
     * Open cancellation/modification dialog
     */
    async manage_assistant_teacherEdit(mt_id) {
      let result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_id: mt_id
      });
      this.editmanage_assistant_teacher = result.data;
      this.committeeCCdialog = true;
    },

    /**
     * Submit file attachment
     */
    async assistantcommitteeFileattachmentDialogSubmit() {
      if (this.$refs.manage_assistant_teacherAttactmentDialogform.validate()) {
        Swal.fire({
          title: "ยืนยันการเสนอรายชื่อกรรมการประเมินครูผู้ช่วย",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก"
        }).then(async result => {
          if (result.isConfirmed) {
            let uploaded = null;
            
            if (this.mt_committe_file !== null) {
              let formData = new FormData();
              let filename = 
                this.editmanage_assistant_teacher.mt_id_card + "." +
                this.time_stamp + ".assistantCommittee.pdf";
              
              formData.append("ApiKey", this.ApiKey);
              formData.append("file", this.mt_committe_file);
              formData.append("filename", "../HRcommitteeAssistantTeach/" + filename);
              
              try {
                let uploadResult = await this.$http.post("uploadfile.php", formData, {
                  headers: { "Content-Type": "multipart/form-data" }
                });
                console.log(uploadResult.data);
                this.editmanage_assistant_teacher.mt_committe_file = filename;
                uploaded = true;
              } catch (error) {
                uploaded = false;
              }
            } else {
              uploaded = false;
            }

            this.editmanage_assistant_teacher.ApiKey = this.ApiKey;
            this.editmanage_assistant_teacher.mt_committe_datetime = new Date();
            this.editmanage_assistant_teacher.mt_committe_ipaapprove = "";
            
            let updateResult = await this.$http.post(
              "manage_assistant_teacher.update.php",
              this.editmanage_assistant_teacher
            );
            
            if (updateResult.data.status == true && uploaded == true) {
              Swal.fire({
                icon: "success",
                title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
                showConfirmButton: false,
                timer: 1500
              });
              await this.manage_assistant_teacherQueryAll();
            } else {
              Swal.fire({
                icon: "warning",
                title: "ดำเนินการผิดพลาด",
                showConfirmButton: false,
                timer: 1500
              });
            }
            this.manage_assistant_teacherAttachmentDialog = false;
          }
        });
      }
    },

    /**
     * Edit Level 1 Committee Member (Qualified Expert)
     */
    async assistantcommitteeL1Edit() {
      let result = await this.$http.post("assistantcommittee.php", {
        ApiKey: this.ApiKey,
        assistantcommitteeTime: this.editmanage_assistant_teacher.mt_times,
        assistantcommitteeYear: this.editmanage_assistant_teacher.mt_years,
        assistantcommitteeIDCardTeach: this.editmanage_assistant_teacher.mt_id_card,
        assistantcommitteePositon: "1"
      });
      this.editassistantcommitteeL1 = result.data;
      this.editassistantcommitteeL1Status = true;
    },

    /**
     * Save Level 1 Committee Member Edit
     */
    async assistantcommitteeL1SaveEditL1() {
 
        await this.sweetAlertLoading();
        
        this.editassistantcommitteeL1Update.ApiKey = this.ApiKey;
        this.editassistantcommitteeL1Update.assistantcommitteeTime = this.editmanage_assistant_teacher.mt_times;
        this.editassistantcommitteeL1Update.assistantcommitteeYear = this.editmanage_assistant_teacher.mt_years;
        this.editassistantcommitteeL1Update.assistantcommitteeIDCardTeach = this.editassistantcommitteeL1.assistantcommitteeIDCardTeach;
        this.editassistantcommitteeL1Update.assistantCommitteeIDcardCommittee = this.editassistantcommitteeL1.assistantCommitteeIDcardCommittee;
        this.editassistantcommitteeL1Update.assistantcommitteePositon = "1";
        
        let result = await this.$http.post(
          "assistantcommittee.update.php",
          this.editassistantcommitteeL1Update
        );
        
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.editassistantcommitteeL1Status = false;
          await this.assistantcommitteeL1Query();
          await this.manage_assistant_teacherQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        Swal.close();
      
    },

    /**
     * Query Level 1 Committee Member
     */
    async assistantcommitteeL1Query() {
      let result = await this.$http.post("assistantcommittee.php", {
        ApiKey: this.ApiKey,
        assistantcommitteeTime: this.editmanage_assistant_teacher.mt_times,
        assistantcommitteeYear: this.editmanage_assistant_teacher.mt_years,
        assistantcommitteeIDCardTeach: this.editmanage_assistant_teacher.mt_id_card,
        assistantcommitteePositon: 1
      });
      this.assistantcommitteeL1s = result.data;
    },

    /**
     * Save new Level 1 Committee Member
     */
    async assistantcommitteeL1Save() {

        this.addassistantcommittee.ApiKey = this.ApiKey;
        this.addassistantcommittee.assistantcommitteeTime = this.editmanage_assistant_teacher.mt_times;
        this.addassistantcommittee.assistantcommitteeYear = this.editmanage_assistant_teacher.mt_years;
        this.addassistantcommittee.assistantcommitteeCollege = this.collegeCheck.college_code;
        this.addassistantcommittee.assistantcommitteeIDCardTeach = this.editmanage_assistant_teacher.mt_id_card;
        this.addassistantcommittee.assistantCommitteeIDcardCommittee = this.addassistantcommittee.assistantCommitteeIDcardCommitteeL1;
        this.addassistantcommittee.assistantcommitteePositon = "1";
        
        let result = await this.$http.post(
          "assistantcommittee.insert.php",
          this.addassistantcommittee
        );
        
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          await this.assistantcommitteeL1Query();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
      
    },

    /**
     * Edit Level 2 Committee Member (Teacher in School)
     */
    async assistantcommitteeL2Edit() {
      let result = await this.$http.post("assistantcommittee.php", {
        ApiKey: this.ApiKey,
        assistantcommitteeTime: this.editmanage_assistant_teacher.mt_times,
        assistantcommitteeYear: this.editmanage_assistant_teacher.mt_years,
        assistantcommitteeIDCardTeach: this.editmanage_assistant_teacher.mt_id_card,
        assistantcommitteePositon: "2"
      });
      this.editassistantcommitteeL2 = result.data;
      this.editassistantcommitteeL2Status = true;
    },

    /**
     * Save Level 2 Committee Member Edit
     */
    async assistantcommitteeL2SaveEditL2() {

        await this.sweetAlertLoading();
        
        this.editassistantcommitteeL2Update.ApiKey = this.ApiKey;
        this.editassistantcommitteeL2Update.assistantcommitteeTime = this.editmanage_assistant_teacher.mt_times;
        this.editassistantcommitteeL2Update.assistantcommitteeYear = this.editmanage_assistant_teacher.mt_years;
        this.editassistantcommitteeL2Update.assistantcommitteeIDCardTeach = this.editassistantcommitteeL2.assistantcommitteeIDCardTeach;
        this.editassistantcommitteeL2Update.assistantCommitteeIDcardCommittee = this.editassistantcommitteeL2.assistantCommitteeIDcardCommittee;
        this.editassistantcommitteeL2Update.assistantcommitteePositon = "2";
        
        let result = await this.$http.post(
          "assistantcommittee.update.php",
          this.editassistantcommitteeL2Update
        );
        
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.editassistantcommitteeL2Status = false;
          await this.assistantcommitteeL2Query();
          await this.manage_assistant_teacherQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        Swal.close();
      
    },

    /**
     * Query Level 2 Committee Member
     */
    async assistantcommitteeL2Query() {
      let result = await this.$http.post("assistantcommittee.php", {
        ApiKey: this.ApiKey,
        assistantcommitteeTime: this.editmanage_assistant_teacher.mt_times,
        assistantcommitteeYear: this.editmanage_assistant_teacher.mt_years,
        assistantcommitteeIDCardTeach: this.editmanage_assistant_teacher.mt_id_card,
        assistantcommitteePositon: 2
      });
      this.assistantcommitteeL2s = result.data;
    },

    /**
     * Save new Level 2 Committee Member
     */
    async assistantcommitteeL2Save() {
     
        this.addassistantcommittee.ApiKey = this.ApiKey;
        this.addassistantcommittee.assistantcommitteeTime = this.editmanage_assistant_teacher.mt_times;
        this.addassistantcommittee.assistantcommitteeYear = this.editmanage_assistant_teacher.mt_years;
        this.addassistantcommittee.assistantcommitteeCollege = this.collegeCheck.college_code;
        this.addassistantcommittee.assistantcommitteeIDCardTeach = this.editmanage_assistant_teacher.mt_id_card;
        this.addassistantcommittee.assistantCommitteeIDcardCommittee = this.addassistantcommittee.assistantCommitteeIDcardCommitteeL2;
        this.addassistantcommittee.assistantcommitteePositon = "2";
        
        let result = await this.$http.post(
          "assistantcommittee.insert.php",
          this.addassistantcommittee
        );
        
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          await this.assistantcommitteeL2Query();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
      
    },

    /**
     * Query personnel temporary data
     */
    async personnel_temporaryQuery() {
      try {
        let result = {};
        if (this.collegeCheck.college_id_code_type_manpower == 6) {
          result = await this.$http.post("personnel_temporary.php", {
            ApiKey: this.ApiKey,
            regiongroup_ID: this.collegeCheck.regiongroup_ID,
            rang_level_check: "ok",
            small_college: "ok"
          });
        } else {
          result = await this.$http.post("personnel_temporary.php", {
            ApiKey: this.ApiKey,
            regiongroup_ID: this.collegeCheck.regiongroup_ID,
            rang_level_check: "ok"
          });
        }
        this.personnel_temporarys = result.data;
      } catch (error) {
        console.error("Error fetching personnel data:", error);
      }
    },

    /**
     * Query qualified committee members
     */
    async assistantcommitteequalifiedQuery() {
      try {
        let result = await this.$http.post("assistantcommitteequalified.php", {
          ApiKey: this.ApiKey,
          assistantcommitteeQualifiedCollege: this.collegeCheck.college_code
        });
        this.assistantcommitteequalifieds = result.data.filter(v => v.assistantcommitteeQualifiedRank != '0');
      } catch (error) {
        console.error("Error fetching qualified committee data:", error);
      }
    },

    /**
     * Add new committee for teacher
     */
    async assistantcommitteeAdd(mt_id) {
      let result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_id: mt_id
      });
      this.editmanage_assistant_teacher = result.data;
      await this.assistantcommitteeL1Query();
      await this.assistantcommitteeL2Query();
      this.assistantcommitteeDialog = true;
    },

    /**
     * Submit committee dialog
     */
    async assistantcommitteeDialogSubmit() {
      this.editmanage_assistant_teacher.ApiKey = this.ApiKey;
      this.editmanage_assistant_teacher.mt_committe_status = "CF";
      this.editmanage_assistant_teacher.mt_admissions_date = new Date();
      
      let result = await this.$http.post(
        "manage_assistant_teacher.update.php",
        this.editmanage_assistant_teacher
      );
      
      if (result.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        this.manage_assistant_teacherQueryAll();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.assistantcommitteeDialog = false;
    },

    /**
     * Query college information
     */
    async collegeQuery() {
      try {
        let userSession = JSON.parse(sessionStorage.getItem("user")) || {};
        let result = await this.$http.post("college.php", {
          college_code: userSession.user_code,
          ApiKey: this.ApiKey
        });
        this.collegeCheck = result.data;
      } catch (error) {
        console.error("Error fetching college data:", error);
      }
    },

    /**
     * Show SweetAlert loading animation
     */
    async sweetAlertLoading() {
      let timerInterval;
      Swal.fire({
        title: "กำลังประมวลผล",
        html: "โปรดรอ...",
        timer: 2000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          clearInterval(timerInterval);
        }
      });
    },

    /**
     * Query all assistant teachers
     */
    async manage_assistant_teacherQueryAll() {
      try {
        this.loading = true;
        let result = await this.$http.post("manage_assistant_teacher.php", {
          ApiKey: this.ApiKey,
          mt_college_code: this.collegeCheck.college_code,
          mt_admissions_status: "receipt"
        });
        this.manage_assistant_teachers = result.data || [];
      } catch (error) {
        console.error("Error fetching assistant teachers:", error);
        this.manage_assistant_teachers = [];
      } finally {
        this.loading = false;
      }
    },

    /**
     * Calculate government service age in years, months, and days
     */
    get_govMonth_Age(date_app_now) {
      let DOB = new Date(date_app_now);
      var today = new Date(),
        result = {
          years: 0,
          months: 0,
          days: 0,
          toString: function() {
            return (
              (this.years ? this.years + " ปี " : "") +
              (this.months ? this.months + " เดือน " : "") +
              (this.days ? this.days + " วัน" : "")
            );
          }
        };
      result.months =
        today.getFullYear() * 12 +
        (today.getMonth() + 1) -
        (DOB.getFullYear() * 12 + (DOB.getMonth() + 1));
      if (0 > (result.days = today.getDate() - DOB.getDate())) {
        var y = today.getFullYear(),
          m = today.getMonth();
        m = --m < 0 ? 11 : m;
        result.days +=
          [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m] +
          (1 == m && y % 4 == 0 && (y % 100 > 0 || y % 400 == 0) ? 1 : 0);
        --result.months;
      }
      result.years = (result.months - (result.months % 12)) / 12;
      result.months = result.months % 12;
      return result;
    }
  },

  computed: {
    /**
     * Calculate total assistant teachers
     */
    totalAssistantTeachers() {
      return this.manage_assistant_teachers.length;
    },

    /**
     * Calculate completed committees
     */
    completedCommittees() {
      return this.manage_assistant_teachers.filter(t => t.mt_committe_status === 'CF' && t.mt_committe_file).length;
    },

    /**
     * Calculate pending committees
     */
    pendingCommittees() {
      return this.manage_assistant_teachers.filter(t => !t.mt_committe_status || t.mt_committe_status === '').length;
    },

    /**
     * Calculate cancelled committees
     */
    cancelledCommittees() {
      return this.manage_assistant_teachers.filter(t => t.mt_committe_status === 'CC').length;
    },

    /**
     * Calculate overdue committees (deadline passed 30+ days)
     */
    overdueCommittees() {
      return this.manage_assistant_teachers.filter(t => t.datediffs > 30 && !t.mt_committe_file).length;
    },

    /**
     * Timestamp for file naming
     */
    time_stamp() {
      return Date.now();
    },

    /**
     * Color scheme for UI
     */
    color() {
      return "blue-grey";
    },

    /**
     * Calculate pagination pages
     */
    pages() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) return 0;
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },

    /**
     * Format current date for logging
     */
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return dd + "/" + mm + "/" + yyyy + " " + time;
    },

    /**
     * Date today for notifications
     */
    date_today() {
      return new Date().toISOString();
    }
  },

  components: { 
    AssisstantBar 
  }
};
</script>
<!-- HRvecManageAssistantTeacher Style Section -->
<style scoped>
/* ============================================
   VARIABLES & FOUNDATIONS
   ============================================ */
:root {
  --primary-color: #2196F3;
  --secondary-color: #1976D2;
  --success-color: #4CAF50;
  --warning-color: #FFC107;
  --danger-color: #F44336;
  --grey-100: #F5F5F5;
  --grey-200: #EEEEEE;
  --grey-300: #E0E0E0;
  --grey-500: #9E9E9E;
  --grey-700: #616161;
  --grey-900: #212121;
  --card-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  --card-shadow-hover: 0 4px 16px rgba(0, 0, 0, 0.15);
  --border-radius: 8px;
}

/* ============================================
   GLOBAL STYLES
   ============================================ */
.app-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
}

/* ============================================
   STATISTICS HEADER SECTION
   ============================================ */
.stats-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 32px 0;
  margin-bottom: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.stat-card {
  background: white;
  border-radius: var(--border-radius);
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: var(--card-shadow);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid var(--grey-200);
}

.stat-card:hover {
  box-shadow: var(--card-shadow-hover);
  transform: translateY(-2px);
}

.stat-card-primary {
  border-left: 4px solid var(--primary-color);
}

.stat-card-success {
  border-left: 4px solid var(--success-color);
}

.stat-card-warning {
  border-left: 4px solid var(--warning-color);
}

.stat-card-danger {
  border-left: 4px solid var(--danger-color);
}

.stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--grey-100);
  color: var(--primary-color);
}

.stat-card-success .stat-icon {
  background: rgba(76, 175, 80, 0.1);
  color: var(--success-color);
}

.stat-card-warning .stat-icon {
  background: rgba(255, 193, 7, 0.1);
  color: var(--warning-color);
}

.stat-card-danger .stat-icon {
  background: rgba(244, 67, 54, 0.1);
  color: var(--danger-color);
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: var(--grey-900);
  line-height: 1;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: var(--grey-500);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

/* ============================================
   CHARTS SECTION
   ============================================ */
.chart-container {
  background: white;
  border-radius: var(--border-radius);
  padding: 24px;
  box-shadow: var(--card-shadow);
  border: 1px solid var(--grey-200);
}

.chart-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--grey-900);
  margin-bottom: 16px;
  margin-top: 0;
  text-transform: none;
}

/* ============================================
   MAIN CARD SECTION
   ============================================ */
.main-card {
  background: white;
  border-radius: var(--border-radius);
  box-shadow: var(--card-shadow);
  border: 1px solid var(--grey-200);
}

.alert-banner {
  background: linear-gradient(135deg, #fff5f5 0%, #fff9f9 100%) !important;
  border: 1px solid #ffebee !important;
  border-radius: 8px !important;
}

.alert-text {
  font-size: 14px;
  color: var(--danger-color);
  display: flex;
  align-items: center;
}

.refresh-btn {
  background: linear-gradient(135deg, #00d4ff 0%, #0099ff 100%) !important;
  color: white !important;
  border-radius: 8px !important;
  text-transform: none !important;
}

/* ============================================
   SEARCH & FILTER SECTION
   ============================================ */
.search-filter-section {
  padding: 8px 0;
}

.search-field {
  background: white !important;
  border-radius: 8px !important;
}

.search-field input {
  font-size: 14px;
}

/* ============================================
   DATA TABLE SECTION
   ============================================ */
.table-container {
  overflow-x: auto;
  border-radius: var(--border-radius);
}

.data-table {
  border-radius: var(--border-radius);
}

.data-table ::v-deep .v-data-table__wrapper {
  border-radius: var(--border-radius);
}

.data-table ::v-deep thead tr {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.data-table ::v-deep thead th {
  color: white !important;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 16px 12px !important;
}

.data-table ::v-deep tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.data-table ::v-deep tbody td {
  padding: 12px !important;
  border-bottom: 1px solid var(--grey-200) !important;
  font-size: 13px;
}

/* Group Header Styling */
.group-header {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
  border: none !important;
  padding: 16px 12px !important;
}

.group-header-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.group-toggle {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.group-toggle.open {
  transform: rotate(180deg);
}

.group-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  flex: 1;
  font-size: 13px;
}

.info-label {
  color: var(--grey-700);
  font-weight: 600;
  white-space: nowrap;
}

.info-value {
  color: var(--grey-900);
  font-weight: 500;
}

.status-badge {
  margin-top: 8px;
}

/* Expanded Row Styling */
.expanded-row {
  background: #fafafa !important;
  padding: 0 !important;
}

.committee-details {
  padding: 16px;
}

.committee-table {
  width: 100%;
  background: white;
  border-radius: 6px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
}

.committee-table thead tr {
  background: var(--grey-100);
}

.committee-table thead th {
  color: var(--grey-700);
  font-weight: 600;
  font-size: 12px;
  padding: 12px;
  text-transform: uppercase;
  border-bottom: 2px solid var(--grey-200);
}

.committee-row {
  transition: background-color 0.2s ease;
}

.committee-row:hover {
  background-color: #f9f9f9;
}

.committee-row td {
  padding: 12px !important;
  border-bottom: 1px solid var(--grey-200) !important;
}

/* Column-specific Styling */
.datetime-cell {
  font-size: 12px;
  color: var(--grey-700);
  white-space: nowrap;
}

.error-detail {
  color: var(--danger-color);
  font-size: 12px;
  font-weight: 500;
}

.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.error-notice {
  display: flex;
  align-items: center;
}

/* No Data State */
.no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  color: var(--grey-500);
}

.no-data-container p {
  margin: 0;
  font-size: 14px;
  margin-top: 12px;
}

/* ============================================
   DIALOG STYLES
   ============================================ */
.dialog-card {
  border-radius: var(--border-radius);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: none;
}

.dialog-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  font-size: 16px;
  padding: 16px 24px !important;
  display: flex;
  align-items: center;
  border-radius: 8px 8px 0 0;
}

.error-title {
  background: linear-gradient(135deg, #f44336 0%, #e91e63 100%);
}

.dialog-body {
  padding: 24px;
  max-height: 65vh;
  overflow-y: auto;
}

.dialog-actions {
  background: var(--grey-100);
  padding: 16px 24px;
  border-top: 1px solid var(--grey-200);
  border-radius: 0 0 8px 8px;
}

/* Teacher Information List */
.teacher-info-list {
  background: var(--grey-100);
  border-radius: 6px;
  padding: 12px 0 !important;
}

.teacher-info-list .v-list-item {
  padding: 8px 12px !important;
}

.teacher-info-list .v-list-item-icon {
  min-width: 36px !important;
}

.teacher-info-list .v-list-item-content {
  padding: 0 12px !important;
}

/* Committee Selection Card */
.committee-selection-card {
  background: white;
  border: 1px solid var(--grey-200);
  border-radius: 6px;
  overflow: hidden;
}

.committee-selection-card ::v-deep .v-simple-table thead tr {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.committee-selection-card ::v-deep .v-simple-table thead th {
  color: white;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  padding: 12px;
}

/* Position Content Styling */
.position-content {
  padding: 12px !important;
}

.selected-person {
  background: linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%);
  border-left: 3px solid var(--success-color);
  padding: 8px 12px;
  border-radius: 4px;
}

.selected-person .font-weight-bold {
  color: var(--success-color);
}

.person-position {
  font-size: 11px;
  color: var(--grey-700);
  margin-top: 4px;
}

/* Autocomplete Item Styling */
.autocomplete-item {
  padding: 8px;
}

.autocomplete-item .font-weight-bold {
  color: var(--primary-color);
  margin-bottom: 4px;
}

/* Committee Summary Card */
.committee-summary-card {
  background: white;
  border: 1px solid var(--grey-200);
}

.committee-summary-card ::v-deep .v-simple-table thead tr {
  background: var(--grey-100);
}

.committee-summary-card ::v-deep .v-simple-table thead th {
  color: var(--grey-700);
  font-weight: 600;
  padding: 12px;
  border-bottom: 2px solid var(--grey-200);
}

/* File Upload Section */
.file-upload-section {
  align-items: flex-end;
}

.print-btn {
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%) !important;
  color: white !important;
}

/* Teacher Details Section */
.teacher-details-section {
  background: var(--grey-100);
  padding: 16px;
  border-radius: 6px;
}

.detail-row {
  display: flex;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 13px;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.detail-label {
  color: var(--grey-700);
  font-weight: 600;
  min-width: 140px;
  white-space: nowrap;
}

.detail-value {
  color: var(--grey-900);
  flex: 1;
}

/* Action Selection Section */
.action-selection-section {
  background: var(--grey-100);
  padding: 16px;
  border-radius: 6px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--grey-900);
  margin-bottom: 12px;
}

.radio-option {
  margin-bottom: 8px;
}

.radio-option ::v-deep .v-radio {
  margin: 0;
}

/* Process Alert */
.process-alert {
  display: flex;
  align-items: center;
  background: #fff3e0;
  border: 1px solid #ffe0b2;
  border-radius: 6px;
  padding: 12px 16px;
  color: #e65100;
  font-size: 13px;
}

.alert-text {
  flex: 1;
}

/* Warning Alert */
.warning-text {
  font-size: 13px;
  color: #e65100;
}

/* PDF Viewer */
.pdf-viewer-card {
  border-radius: 8px;
}

.pdf-title {
  background: var(--grey-100);
  color: var(--grey-900);
  font-weight: 600;
  padding: 16px 24px !important;
}

/* ============================================
   VUETIFY OVERRIDES
   ============================================ */
.v-chip {
  font-size: 12px;
  border-radius: 4px;
}

.v-btn {
  text-transform: none;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.v-btn:hover {
  text-transform: none;
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */
@media (max-width: 960px) {
  .stats-header {
    padding: 24px 0;
  }

  .stat-card {
    margin-bottom: 16px;
  }

  .group-info {
    gap: 8px;
  }

  .dialog-body {
    max-height: 70vh;
  }

  .data-table ::v-deep tbody td {
    padding: 8px 6px !important;
    font-size: 12px;
  }

  .detail-label {
    min-width: 100px;
  }
}

@media (max-width: 600px) {
  .stats-header {
    padding: 16px 0;
  }

  .stat-card {
    padding: 16px;
    gap: 12px;
  }

  .stat-value {
    font-size: 24px;
  }

  .stat-label {
    font-size: 11px;
  }

  .group-header-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .group-info {
    flex-direction: column;
    gap: 6px;
  }

  .dialog-body {
    padding: 16px;
    max-height: 75vh;
  }

  .detail-row {
    flex-direction: column;
    gap: 4px;
  }

  .detail-label {
    min-width: auto;
  }

  .file-upload-section {
    flex-direction: column;
  }

  .print-btn {
    margin-bottom: 0;
    width: 100%;
  }
}

/* ============================================
   ANIMATIONS & TRANSITIONS
   ============================================ */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.stat-card {
  animation: slideInUp 0.4s ease-out forwards;
}

.stat-card:nth-child(1) { animation-delay: 0.1s; }
.stat-card:nth-child(2) { animation-delay: 0.2s; }
.stat-card:nth-child(3) { animation-delay: 0.3s; }
.stat-card:nth-child(4) { animation-delay: 0.4s; }

.chart-container {
  animation: fadeIn 0.6s ease-out;
}

.main-card {
  animation: fadeIn 0.8s ease-out;
}

/* ============================================
   ACCESSIBILITY IMPROVEMENTS
   ============================================ */
.v-data-table ::v-deep tbody tr:focus {
  outline: 2px solid var(--primary-color);
  outline-offset: -2px;
}

.v-btn:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

/* ============================================
   PRINT STYLES
   ============================================ */
@media print {
  .stats-header,
  .search-filter-section,
  .dialog-actions,
  .action-buttons {
    display: none;
  }

  .data-table {
    box-shadow: none;
    border: 1px solid #ccc;
  }
}

/* ============================================
   UTILITY CLASSES
   ============================================ */
.text-alert {
  font-size: 14pt;
  color: var(--danger-color);
}

.pending-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: var(--grey-100);
  border-radius: 4px;
  font-size: 12px;
  color: var(--grey-700);
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-chip {
  margin: 0;
}

.file-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>